<template>
  <div @click="clickImageMarker" ref="imageMarker" class="imageMarker alibabaPuHuiTiFontFamily"
       :style="{'background-image':'url(' + imageMarkerInfo.thumb + ')'}">

    <p class="imageMarker-title" style="">{{imageMarkerInfo.title}}</p>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import * as turf from '@turf/turf'
export default {
  name: "ImageMarker",
  props:["imageMarkerInfo"],
  data() {
    return {
      marker: ''
    }
  },
  methods:{
    clickImageMarker(){
      this.$emit("clickImageMarker",this.imageMarkerInfo)
    }
  },
  mounted() {
    var center = turf.center(JSON.parse(this.imageMarkerInfo.geo));
    this.marker = new mapboxgl.Marker(this.$refs.imageMarker)
        .setLngLat([center.geometry.coordinates[0], center.geometry.coordinates[1]])
        .addTo(this.$parent.$parent.map)
  },
  destroyed() {
    this.marker.remove()
  },
  render() {
    return null;
  },

}
</script>

<style scoped>

.imageMarker{
  position:absolute;
  width:120px;
  height:120px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  border-radius:10px;
  background-size:cover;
  background-position: center;
  cursor:pointer;
}

/*背景图四周做成模糊效果*/
.imageMarker:after {
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius:9px;
  box-shadow:0 0 4px 1px rgba(255,255,255,0.8) inset;
}


.imageMarker-title{
  position:absolute;
  bottom:5px;
  left:8px;
  width:calc(100% - 16px);
  text-align:center;
  font-size:16px;
  color:#ffffff;
  font-weight:bold;
  text-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.75);
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

</style>